import { useRecoilState } from 'recoil'
import { IProject, IProjectSlot, ISlotTeamMemberRole } from '../projects.types'
import { useEffect } from 'react'
import projectsAtom from '../projects.atom'
import projectsApi from '../projects.api'
import useSkipFirstRenderEffect from 'shared/hooks/useSkipFirstRenderEffect'
import useHttpLoader from 'shared/hooks/useHttpLoader'

const useSlotTeamMemberRoles = (projectId: IProject['id'], slotId: IProjectSlot['id']) => {

  const { wait, loading } = useHttpLoader()
  const [projectState, setProjectState] = useRecoilState(projectsAtom);

  const setSlotTeamMemberRoles = (slotTeamMemberRoles: ISlotTeamMemberRole[]) => {
    setProjectState((prev) => ({
      ...prev,
      slotTeamMemberRoles,
    }))
  }

  useSkipFirstRenderEffect(() => {
    wait(projectsApi.getProjectSlotTeamMemberRoles(projectId, slotId), (r) => {
      if (r.status === 'success') {
        setProjectState((prev) => ({
          ...prev,
          slotTeamMemberRoles: r.body
        }))
      }
    })
  }, [])

  useEffect(() => {
    projectsApi.getProjectSlotTeamMemberRoles(projectId, slotId).then((r) => {
      if (r.status === 'success') {
        setProjectState((prev) => ({
          ...prev,
          slotTeamMemberRoles: r.body
        }))
      }
    })
  }, [projectId, slotId])


  return {
    loading,
    slotTeamMemberRoles: projectState.slotTeamMemberRoles,
    setSlotTeamMemberRoles,
  }
}

export default useSlotTeamMemberRoles
